module.exports = "<span class=\"msg\">\r\n  <mat-icon class=\"icon\">\r\n   flash_on \r\n  </mat-icon>\r\n  {{ data.msg }}\r\n</span>\r\n"